import React from 'react'

function TopFooter() {
  return (
  
     <div className="top-footer">
    <h3>Follow me on social media</h3>
      <div className="footer-icons">
          <a href="https://www.linkedin.com/in/abdelmoniem-ahmed-3751761b7/" target=' _blank '>
            <i className="bi bi-linkedin"></i></a>
        <a href="https://github.com/Abdelmoniemhgagyy?tab=projects" target=' _blank '><i className="bi bi-github"></i></a>
            <a href="https://api.whatsapp.com/send?phone=%2B201557221816&amp;dat
                a=ARD0Zh9NsRHYnFZYHPG8McNvfVgQa7rFk5Fn08mKrUOWkySeHej6NE-C6pt0t6RZL3YKrf-8-6AWiG60BCsvLbucbRbhDcRGsDpLGpsQO7MV1m5Thm9saVqj-
                -W-Ds253VJy7XHdxJGto3oKIWNxILbmgg&amp;source=FB_Page&amp;app=facebook&amp;entry_point=page_cta" target=" _blank ">
                    <i className="bi bi-whatsapp"></i>
                </a>
            <a href="https://www.facebook.com/profile.php?id=100007656874900" target=' _blank '><i className="bi bi-facebook"></i></a>
          <a href="https://t.me/hgagq" target=' _blank '><i className="bi bi-telegram"></i></a>
        
      </div>
       
     </div>
    
  )
}

export default TopFooter